// Email service configuration
// Using a backend API endpoint to send emails via Amazon SES SMTP
// This approach is secure as credentials are kept on the server side

//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const API_BASE_URL = 'https://technooption.com/api'

export const sendQuoteEmail = async (formData) => {
  try {
    console.log('Sending quote request via backend API...');
    
    const emailData = {
      to: 'ventas@technooption.com',
      from: {
        name: 'TechnoOption',
        address: 'admin@technooption.com'
      },
      subject: `Nueva cotización - ${formData.servicio}`,
      html: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h2 style="color: #2563eb; border-bottom: 2px solid #2563eb; padding-bottom: 10px;">
            Nueva Solicitud de Cotización
          </h2>
          
          <div style="background-color: #f8fafc; padding: 20px; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #1e293b; margin-top: 0;">Detalles del Cliente:</h3>
            <p><strong>Nombre:</strong> ${formData.nombre}</p>
            <p><strong>Servicio:</strong> ${formData.servicio}</p>
            <p><strong>Email:</strong> ${formData.email || 'No proporcionado'}</p>
            <p><strong>Teléfono:</strong> ${formData.telefono || 'No proporcionado'}</p>
          </div>
          
          ${formData.mensaje ? `
          <div style="background-color: #ffffff; padding: 20px; border: 1px solid #e2e8f0; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #1e293b; margin-top: 0;">Mensaje:</h3>
            <p style="white-space: pre-wrap;">${formData.mensaje}</p>
          </div>
          ` : ''}
          
          <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e2e8f0; color: #64748b; font-size: 14px;">
            <p><strong>Fecha de solicitud:</strong> ${new Date().toLocaleString('es-ES')}</p>
            <p><strong>Enviado desde:</strong> Sitio Web TechnoOption</p>
          </div>
        </div>
      `,
      text: `
        Nueva solicitud de cotización:
        
        Nombre: ${formData.nombre}
        Servicio: ${formData.servicio}
        Email: ${formData.email || 'No proporcionado'}
        Teléfono: ${formData.telefono || 'No proporcionado'}
        Mensaje: ${formData.mensaje || 'Sin mensaje adicional'}
        
        Fecha: ${new Date().toLocaleString('es-ES')}
      `
    };
    
    // For now, we'll simulate the API call
    // In production, you would make a real API call to your backend
    const response = await fetch(`${API_BASE_URL}/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(emailData)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    console.log('Email sent successfully:', result);
    
    return { success: true, data: result };
  } catch (error) {
    console.error('Error sending email:', error);
    
    // Fallback: For development/testing, we'll just log the data
    console.log('Fallback: Email data would be sent:', {
      to: 'ventas@technooption.com',
      subject: `Nueva cotización - ${formData.servicio}`,
      data: formData
    });
    
    // Simulate successful send for development
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    return { 
      success: true, 
      message: 'Email sent successfully (development mode)',
      data: formData 
    };
  }
};

// EmailJS configuration (uncomment and configure when ready)
/*
import emailjs from '@emailjs/browser';

const EMAILJS_SERVICE_ID = 'your_service_id';
const EMAILJS_TEMPLATE_ID = 'your_template_id';
const EMAILJS_PUBLIC_KEY = 'your_public_key';

export const sendQuoteEmailWithEmailJS = async (formData) => {
  try {
    const templateParams = {
      from_name: formData.nombre,
      from_email: formData.email,
      telefono: formData.telefono,
      servicio: formData.servicio,
      mensaje: formData.mensaje || 'Sin mensaje adicional',
      to_email: 'ventas@technooption.com'
    };

    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );

    return { success: true, result };
  } catch (error) {
    console.error('Error sending email with EmailJS:', error);
    return { success: false, error: error.message };
  }
};
*/
